import { Alert, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BiCalendarCheck, BiError } from "react-icons/bi";
import { CRIMSON_RED } from "../../enums/Colors";
import usePrimaryColor from "../../hooks/usePrimaryColor";
export default function SimpleIconAlert({
  message,
  severity = "error",
  color = "",
}) {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      height={"100%"}
      color={color}
    >
      <Icon severity={severity} />
      <Typography variant="h5" fontWeight="bold" mt={2}>
        {t(message)}
      </Typography>
    </Box>
  );
}

function Icon({ severity = "error" }) {
  const color = usePrimaryColor();
  const iconSize = 150;

  if (String(severity).toLowerCase() === "info") {
    return <BiCalendarCheck color={color} size={iconSize} />;
  }
  return <BiError color={CRIMSON_RED} size={iconSize} />;
}

export function ComplexIconButtonAlert({
  message,
  severity = "error",
  icon,
  iconSize = "4rem",
  children,
  titleVariant = "subtitle2",
}) {
  const { t } = useTranslation();
  return (
    <Alert
      severity={severity}
      icon={icon}
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        "& .MuiAlert-icon": {
          fontSize: iconSize,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "center",
          marginLeft: "auto", // Push icon from the left to center it
        },
        "& .MuiAlert-message": {
          marginRight: "auto", // Push text from the right to center it
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          variant={titleVariant}
          component="div"
          sx={{ textAlign: "center" }}
        >
          {t(message)}
        </Typography>
        {children && <Box mt={1}>{children}</Box>}
      </Box>
    </Alert>
  );
}
